export const CLASS_NAMES = {
  BNPLNotice: 'mb-5 text-12-18 text-neutral-600',
};

export const BNPL_NOTICE =
  'Enjoy {{deferredDuration}} number of months before repayment starts where you can choose to pay nothing, some, or all of the balance with no interest (£29 admin fee applies); the remaining balance is then repaid over {{loanDuration}} months at {{loanApr}}% APR.';
